<div class="spacer" [ngStyle]="{'margin-top' : size/2 + 'px', 'margin-bottom' : size/2 + 'px'}">&nbsp;</div>
